import DOMPurify from 'dompurify';
import { format, parse } from 'date-fns'

export const normalizePath = path => {

	const pathStr = path.split( '/');

	// If the path ends with '/' get the second last item
	if ( path?.endsWith( `/` ) ) {

		const strIndex = pathStr.length ? ( pathStr.length - 2 ) : '';

		if ( strIndex ) {
			path = `/${ pathStr[ strIndex ] }/`
		}
	}

	// If the path ends with '/' get the second last item.
	if ( ! path?.endsWith( `/` ) ) {
		const strIndex = pathStr.length ? ( pathStr.length - 1 ) : '';

		if ( strIndex ) {
			path = `/${ pathStr[ strIndex ] }/`
		}
	}

	return path;

}
/**
 * Get date in format of m-d-y
 *
 * @param {string} dateString Date string, example 2020-05-03T04:41:12
 *
 * @return {string}
 */
export const getFormattedDate = ( dateString, dateFormat = "DD-MM-YYYY", options = null ) => {

	if ( ! dateString ) {
		return '';
	}

	const locale = process.env.GATSBY_SITE_LANG.replace('_','-')
	var date

	if (options === "raw") {
		date = new Date( dateString );
	} else {
		date = new Date( parse(dateString, 'dd/MM/yyyy', new Date()) );
	}

	if (dateFormat === "DD-MM-YYYY") {
		return `${date.toLocaleDateString(locale, { year: "numeric", month: "numeric", day: "numeric"})}`;
	}

	if (dateFormat === "D MMMM Y") {
		return `${date.toLocaleDateString(locale, { year: "numeric", month: "long", day: "numeric"})}`;
	}

	if (dateFormat === "YYYYMMDD") {
		return format(date, "yyyyMMdd")
	}

};

/**
 * Remove the trailing slash from a string.
 *
 * @param {String } targetString Target string.
 * @return {string} String with trailing slash removed.
 */
export const removeTrailingSlash = ( targetString ) => {
	if ( ! targetString ) {
		return '';
	}

	return targetString.replace(/\/$/, "")
}

/**
 * Sanitize markup or text when used inside dangerouslysetInnerHTML
 *
 * @param {string} content Plain or html string.
 *
 * @return {string} Sanitized string
 */
export const sanitize = (content) => {

	// return typeof window === 'undefined' ? DOMPurify.sanitize(content) : content

	return content;

}

/**
 * Strip Html tags from string
 *
 * @param {string} content Plain or html string.
 *
 * @return {string} Stripped string
 */
export const removeTags = (str) => {

    if ((str===null) || (str===''))
        return false;
    else
        str = str.toString();
          
    // Regular expression to identify HTML tags in 
    // the input string. Replacing the identified 
    // HTML tag with a null string.
    return str.replace( /(<([^>]+)>)/ig, '');
}
